export default "__VITE_ASSET__Bvowjn8N__"